module.exports = __webpack_public_path__ + "static/img/shopcar_no.744c2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/shopcar_no.png
// module id = n0Bq
// module chunks = 0